
import React from 'react';
import Base from './Base';
import config from './config';

/**
 * Menu component for navigation links and actions
 */

const Menu = ({ rounded = true, ...props }) => {
  const { scale, colors, borderColor, borderRadius } = config;

  return (
    <Base
      {...props}
      rounded={rounded}
      className="Menu"
      baseStyle={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: 128,
        marginBottom: scale[2],
        overflow: 'hidden',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor,
        borderRadius,
        color: colors.black,
        backgroundColor: colors.white,
      }}
    />
  );
};

export default Menu;

